import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Recepcion_parcialComponent = /** @class */ (function () {
    function Recepcion_parcialComponent() {
        this.rows = [];
        this.form = new FormGroup({
            superedif: new FormControl(''),
            cambios: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("recepcion_parcial"))) {
            localStorage.setItem("recepcion_parcial", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("recepcion_parcial"));
            this.form.controls['cambios'].setValue(this.rows[0] ? this.rows[0].cambios : false);
            this.form.controls['superedif'].setValue(this.rows[0] ? this.rows[0].superedif : '');
        }
        this.recepcion_parcial = { superedif: '', cambios: '' };
    }
    Recepcion_parcialComponent.prototype.add_recepcion = function () {
        localStorage.setItem("recepcion_parcial", JSON.stringify([]));
        this.actualRow = localStorage.getItem("recepcion_parcial");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            superedif: this.form.value.superedif,
            cambios: this.form.value.cambios
        });
        localStorage.setItem("recepcion_parcial", JSON.stringify(this.rows));
    };
    Recepcion_parcialComponent.prototype.delete_recepcion = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("recepcion_parcial", JSON.stringify(this.rows));
            }
        }
    };
    return Recepcion_parcialComponent;
}());
export { Recepcion_parcialComponent };
